
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebc01"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebc01"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $cKvYK = parcelRequire("cKvYK");

var $kc00y = parcelRequire("kc00y");

var $cJHfb = parcelRequire("cJHfb");

var $cKvYK = parcelRequire("cKvYK");

var $w7gBZ = parcelRequire("w7gBZ");

var $lpki3 = parcelRequire("lpki3");

var $eqMOn = parcelRequire("eqMOn");
parcelRequire("0ZkzX");
parcelRequire("b3CnJ");



var $bNJBP = parcelRequire("bNJBP");

/**
 * Contient les pages publics du site, où le userInfo n'est pas forcément renseigné
 */ const $fa6f8baabe309670$var$Index = ()=>{
    return /*#__PURE__*/ (0, $cKvYK.jsx)((0, $w7gBZ.BrowserRouter), {
        children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $eqMOn.AppProvider), {
            children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $bNJBP.MainContainer), {
                children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $lpki3.default), {})
            })
        })
    });
};
var $fa6f8baabe309670$export$2e2bcd8739ae039 = $fa6f8baabe309670$var$Index;


const $9e298d4cbc305cdb$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($cJHfb))).createRoot(document.getElementById("root"));
$9e298d4cbc305cdb$var$root.render(/*#__PURE__*/ (0, $cKvYK.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kc00y))).StrictMode, {
    children: /*#__PURE__*/ (0, $cKvYK.jsx)((0, $fa6f8baabe309670$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.65fcea10.js.map
